<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">设备配置</span>
    </p>
    <div style="position: relative;">
      <TableWrapper
        v-if="showModal"
        :columns="columns"
        :offset-height="offsetHeight"
        :mod-count="modCount"
        :url="action"
        :border="false"
        :show-add="addPermited"
        @on-add="showFormModalDialog"
      />
      <ParkingAgentDeviceDialog
        :id="entityId"
        :agent-id="agentId"
        :parking-id="parkingId"
        :visible="modalForm"
        :width="350"
        @on-close="onAgentModalClose"
      />
    </div>
  </Modal>
</template>

<script>
import request from '@/utils/request'
import TableWrapper from '@/components/table-wrapper'
import ParkingAgentDeviceDialog from './dialog/parkingAgentDeviceDialog'
import { getLinkTextStyle } from '@/utils/util'
import { isAdmin, hasPermission } from '@/utils/app'
export default {
  name: 'ParkingAgentDeviceListDialog',
  components: {
    TableWrapper, ParkingAgentDeviceDialog
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 500
    },
    agentId: {
      type: Number,
      default: 0
    },
    parkingId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loadingStatus: false,
      modal: true,
      modalForm: false,
      submit: false,
      modCount: 0,
      entityId: 0
    }
  },
  computed: {
    addPermited() { return isAdmin() || hasPermission('PEM_GARAGE_AGENT_DEVICE_ADD') },
    deletePermitted() { return isAdmin() || hasPermission('PEM_GARAGE_AGENT_DEVICE_DELETE') },
    updatePermitted() { return isAdmin() || hasPermission('PEM_GARAGE_AGENT_DEVICE_UPDATE') },
    offsetHeight() {
      return 480
    },
    action() {
      return this.$config.apiContextPath + '/parking/' + this.parkingId + '/agent/' + this.agentId + '/device'
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    },
    columns() {
      return [
        { title: '序号', type: 'index', width: 70, align: 'center' },
        { title: '设备类型', align: 'center', key: 'deviceType', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            const deviceTypes = this.$config.deviceTypes
            const matched = deviceTypes.filter(t => t.value === params.row.deviceType)
            return h('span', {}, matched && matched.length > 0 ? matched[0].label : '---')
          }
        },
        { title: '进/出', align: 'center', key: 'deviceInOut', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.deviceInOut === 1 ? '进' : '出')
          }
        },
        { title: '设备标识', align: 'center', key: 'label', sortable: true, ellipsis: true, tooltip: true },
        { title: '状态', align: 'center', key: 'status', sortable: true, width: 80, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {
              style: { color: params.row.status === 1 ? 'green' : 'red' }
            }, params.row.status === 1 ? '启用' : '停用')
          }
        },
        { title: '创建时间', align: 'center', sortable: true, key: 'createTime', width: 160, ellipsis: true, tooltip: true },
        { title: '操作', align: 'center', width: 140,
          render: (h, params) => {
            const _this = this
            return h('div', [
              h('a', {
                style: getLinkTextStyle(_this.updatePermitted),
                on: {
                  click: () => {
                    if (params.row.id && _this.updatePermitted) {
                      this.showFormModalDialog(params.row.id)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-edit': true, 'cell-icon-link': true }}),
                h('span', { domProps: { title: _this.updatePermitted ? '编辑车库终端' : '您没有权限编辑车库终端' }}, '编辑')
              ]),
              h('a', {
                style: getLinkTextStyle(_this.deletePermitted),
                on: {
                  click: () => {
                    if (params.row.id && _this.deletePermitted) {
                      this.showDelModalDialog(params.row.id, params.row.label)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-trash': true, 'cell-icon-link': true }}),
                h('span', { domProps: { title: _this.deletePermitted ? '删除车库终端' : '您没有权限删除车库终端' }}, '删除')
              ])
            ])
          }
        }
      ]
    }
  },
  watch: {
    showModal(val) {
    }
  },
  methods: {
    showFormModalDialog: function(id) {
      this.entityId = id ? parseInt(id) : 0
      this.modalForm = true
    },
    onAgentModalClose: function(changed = false) {
      this.modalForm = false
      if (changed) {
        this.modCount = this.modCount + 1
      }
    },
    showDelModalDialog: function(id, label) {
      const _this = this
      this.$Modal.confirm({
        title: '确认删除终端设备么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0' }}, [h('li', {}, label)])
        },
        onOk: function() {
          const _that = this
          request({
            url: _this.action + '/' + id,
            method: 'DELETE'
          }).then(res => {
            this.$Notice.success({
              title: '数据删除成功',
              desc: '终端设备删除成功!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '数据删除失败',
              desc: '终端设备删除失败, 错误信息: ' + error
            })
            _that.buttonLoading = false
          })
        }
      })
    },
    closeModal: function(changed = false) {
      this.url = ''
      this.entityId = 0
      this.$emit('on-close', changed)
    }
  }
}
</script>
